import { AType, summon } from "@silversea-ssc/functional-support"

export const CheckoutFlowType = summon((F) =>
    F.keysOf({
        ECommerce: null,
        CourtesyHold: null,
    }),
)
export type CheckoutFlowType = AType<typeof CheckoutFlowType>
